(function () {
  'use strict';

  function playVideo(button) {
    var videoId = button.getAttribute('data-merlons-video-id');
    if (!videoId || button.getAttribute('data-merlons-video-loaded') === 'true') return;

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    iframe.title = button.getAttribute('aria-label') || 'Video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'eager';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.className = 'merlons-video-gallery__player';
    iframe.tabIndex = 0;

    button.setAttribute('data-merlons-video-loaded', 'true');
    button.replaceWith(iframe);
    window.setTimeout(function () { iframe.focus(); }, 0);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-merlons-video-id]');
    if (button) playVideo(button);
  });
}());
